import ellipse1 from '@/shared/assets/login/ellipse-1.svg';
import ellipse2 from '@/shared/assets/login/ellipse-2.svg';
import ellipse3 from '@/shared/assets/login/ellipse-3.svg';
import symbol from '@/shared/assets/login/symbol.svg';
import union from '@/shared/assets/login/union.svg';
import { RudalinkLogo } from '@/shared/ui';

/**
 * Figma 로그인 left/img — 하늘색 카드 위에 흐린 원·심볼을 겹친 일러스트 + 로고 문구.
 * 레이어 위치는 Figma 프레임(672 × 852) 기준 px. 각 SVG는 블러 영역까지 포함해 바깥으로 넘친다.
 */
export function LoginIllustration() {
  return (
    <div className="relative h-full w-full overflow-clip rounded-24 bg-sky-100">
      <div className="absolute top-[70.5px] left-0 h-[711px] w-[803px]">
        <div className="absolute" style={{ inset: '-56.26% -49.81%' }}>
          <img src={ellipse1} alt="" className="block size-full max-w-none" />
        </div>
      </div>
      <div className="absolute top-[-195px] left-[-74px] h-[675px] w-[820px]">
        <div className="absolute" style={{ inset: '-29.63% -24.39%' }}>
          <img src={ellipse2} alt="" className="block size-full max-w-none" />
        </div>
      </div>
      <div className="absolute top-[393px] left-[-74px] h-[675px] w-[820px] -scale-y-100">
        <div className="absolute" style={{ inset: '-29.63% -24.39%' }}>
          <img src={ellipse3} alt="" className="block size-full max-w-none" />
        </div>
      </div>
      <div className="absolute top-1/2 left-1/2 h-[300px] w-[404px] -translate-x-1/2 -translate-y-1/2">
        <div className="absolute" style={{ inset: '-50% -37.13%' }}>
          <img src={union} alt="" className="block size-full max-w-none" />
        </div>
      </div>
      <img
        src={symbol}
        alt=""
        className="absolute top-8 left-8 block size-16"
      />
      <div className="absolute top-[120px] left-8 flex w-[293px] flex-col gap-2">
        <RudalinkLogo />
        <p className="text-[32px] leading-normal font-medium tracking-[-0.035em] text-fg-white">
          Partner Station
        </p>
      </div>
    </div>
  );
}
